/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';
import _ from 'lodash';
import './ticket.scss';

import {
  getRemainQuantity,
  count,
  canAdd,
  canRemove
} from '/client/src/utils/buyService';
import { currency, TicketFeeType } from '/client/src/constants/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { format } from '/client/src/utils/amountTransformation';
import { getPieOptions } from '../utils';

type TicketItemPropsType = {
  eventDetail: {
    default_currency: string,
    discounts: [],
    show_remaining_ticket_count: boolean
  },
  ticket: {
    sale_end_time_utc: string,
    fee_type?: string,
    sparxo_fee?: number,
    merchant_fee?: number,
    payment_method_additional_fee?: string | number,
    payment_method_additional_fix_fee: string | number,
    price: number,
    price_with_discount?: number,
    discount_amount: number,
    tax_use_percentage: boolean,
    tax_percentage: number,
    tax: number,
    description?: string,
    short_description?: string,
    amount: number,
    id: string,
    name: string,
    discount_fee?: *
  },
  onHandleRemoveTicket: () => void,
  onHandleAddTicket: () => void,
  visibleTickets: [],
  buyCart: [],
  isVip?: boolean
};

const Ticket = (props: TicketItemPropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const [isShowFullInfo, setShowFullInfo] = React.useState(false);
  const dL = getPieOptions(props);
  const currentCountTicket = count(props, props.ticket.id);

  let fee = props.ticket.merchant_fee;

  if (props.ticket.fee_type === TicketFeeType.ExcludeFee) {
    fee = (props.ticket.merchant_fee +
      props.ticket.payment_method_additional_fee +
      props.ticket.payment_method_additional_fix_fee +
      props.ticket.sparxo_fee);
  }

  const display_price = (): number => {
    return Math.max(props.ticket.price - props.ticket.discount_amount, 0);
  };

  const tax = (): number => {
    const _price = display_price();

    if (props.ticket.tax_use_percentage) {
      return _price * (props.ticket.tax_percentage / 100);
    }

    return props.ticket.tax;
  };

  const _getRemainQuantity: number = getRemainQuantity(props.eventDetail, true, props.ticket);

  if (_getRemainQuantity === 0) {
    const footer = document.querySelector('.sparxo-embeded-footer');

    if (footer) {
      footer.style.display = 'none';
    }
  }

  return (
    <div className={`sparxo-checkout-Ticket_wrapper ${props.isVip ? 'sparxo-checkout-Ticket_wrapperForVip' : ''}`}>
      {props.isVip && <div className={'sparxo-checkout-Ticket_vipMarker'}>SECRET TICKET</div>}
      <div className={'sparxo-checkout-Ticket_wrapperBefore'} />
      <div className={`sparxo-checkout-Ticket_ticket ${isShowFullInfo ? 'sparxo-checkout-Ticket_ticketFullSize' : ''}`}>
        <div className={'sparxo-checkout-Ticket_info'}>
          {/* header*/}
          <div>
            <span className={'sparxo-checkout-Ticket_title'}>{props.ticket.name}</span>
            <span className={'sparxo-checkout-Ticket_subtitle'}>
              {`${dL.value} ${dL.unit}`}
            </span>
            {props.eventDetail.show_remaining_ticket_count &&
              <div className="sparxo-checkout-Ticket_remain">
                {_getRemainQuantity} Tickets Remaining
              </div>
            }
          </div>
          {/* description*/}
          <div className={'sparxo-checkout-Ticket_description'}>
            <>
                {!!_.size(props.ticket.short_description) &&
                  <div className={`${!isShowFullInfo ? 'sparxo-checkout-Ticket_isShowShortInfo' : ''}`}>
                    {props.ticket.short_description}
                  </div>
                }
                {!!props.ticket.description && !!_.size(props.ticket.description.trim()) &&
                  <>
                    {isShowFullInfo && <div>{props.ticket.description}</div>}
                    <div
                      /* eslint-disable-next-line max-len */
                      className={`sparxo-checkout-Ticket_moreInfo ${!isShowFullInfo ? 'sparxo-checkout-Ticket_moreInfoLess' : ''}`}
                      onClick={(): void => setShowFullInfo(!isShowFullInfo)}
                    >
                      {!isShowFullInfo ? 'more' : 'less'} ticket info
                    </div>
                  </>
                }
              </>
          </div>
        </div>
        {/* price*/}
        <div className={'sparxo-checkout-Ticket_price'}>
          <div className={'sparxo-checkout-Ticket_amount'}>
            {display_price() > 0 ? format(currency[`${context.profileCurrent.currency}`], display_price()) : 'Free'}
          </div>
          {fee > 0 &&
          <div className={'sparxo-checkout-Ticket_fee'}>
            <span>fee </span>
            {format(currency[`${context.profileCurrent.currency}`],
              props.ticket.discount_fee ? props.ticket.discount_fee : fee)
            }
          </div>
          }
          {tax(props) > 0 &&
          <div className={'sparxo-checkout-Ticket_tax'}>
            <span>tax </span>
            {format(currency[`${context.profileCurrent.currency}`], tax(props))}
          </div>
          }
        </div>
        {/* ticket count*/}
        <div className={'sparxo-checkout-Ticket_count'}>
          {_getRemainQuantity === 0 ?
            <div className="sparxo-checkout-Ticket_soldOut-container">
              <div className="sparxo-checkout-Ticket_soldOut">Sold out</div>
            </div>
            :
            <div className={`sparxo-checkout-Ticket_countContainer ${currentCountTicket > 0 ? 'sparxo-checkout-Ticket_isNoZero' : ''}`}>
              <button
                type="button"
                className={'sparxo-checkout-Ticket_countBtn'}
                disabled={!canRemove(props, props.ticket.id)}
                onClick={() => {
                  if (canRemove(props, props.ticket.id)) {
                    props.onHandleRemoveTicket(props.ticket);
                  }
                }}
              />
              <div className={'sparxo-checkout-Ticket_countCurrent'}>
          <span className={'sparxo-checkout-Ticket_countCurrentText'}>
            {count(props, props.ticket.id)}
          </span>
              </div>
              <button
                type="button"
                className={'sparxo-checkout-Ticket_countBtn sparxo-checkout-Ticket_countBtnPlus'}
                disabled={!canAdd(props.eventDetail, props.ticket, props.visibleTickets, props.buyCart)}
                onClick={() => {
                  if (canAdd(props.eventDetail, props.ticket, props.visibleTickets, props.buyCart)) {
                    props.onHandleAddTicket(props.ticket);
                  }
                }}
              />
            </div>
          }
        </div>
      </div>
      <div className={'sparxo-checkout-Ticket_wrapperAfter'} />
    </div>
  );
};

export default Ticket;
